import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';
import { operationsForSelectable } from '../constants/operationsForSelectable';

const items = 150;
const fields = '_id date operationType comments transactions';

export const getOperationsForSelectorMenu = async (societyId: string) => {
  const query = {
    params: { societyId, fields, items, filterBy: operationsForSelectable },
  };

  try {
    const { data } = await axiosV2.get('/operations', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    return [];
  }
};
